import {Observable}                from 'rxjs';
import {debounceTime, filter, map} from 'rxjs/operators';
import {TestScheduler}             from 'rxjs/testing';

import UiEventType            from '../../../../Ui/Shared/Constants/UiEventType';
import IUiEventsStreamPayload from '../../../../Ui/Shared/Interfaces/IUiEventsStreamPayload';

const DEBOUNCE_DURATION = 200;

const createDeactivateSliderStream = (
    uiEvent$: Observable<IUiEventsStreamPayload>,
    scheduler?: TestScheduler
): Observable<void> =>
    uiEvent$
        .pipe(
            filter(({type}) => type === UiEventType.VOLUME_SLIDER_DRAG_END),
            debounceTime(DEBOUNCE_DURATION, scheduler),
            map(() => void 0)
        );

export default createDeactivateSliderStream;